import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import * as R from 'ramda'

const activeAddProductFamilyDialogSelector = state => state.admin.partnerSiteProductFamily.activeAdd
const partnerSiteQuerySelector = state => state.admin.partnerSiteProductFamily.partnerSiteQuery
const partnerSiteListSelector = state => state.admin.partnerSiteProductFamily.partnerSiteList
const selectedPartnerSite = state => state.admin.partnerSiteProductFamily.selectedPartnerSite
const productFamilyListSelector = state => state.admin.partnerSiteProductFamily.productFamilyList
const selectedProductFamily = state => state.admin.partnerSiteProductFamily.selectedProductFamily
const productFamilyPartnerSiteTableList = state => state.admin.partnerSiteProductFamily.productFamilyPartnerSiteTableList
const selectedPfpsSelector = state => state.admin.partnerSiteProductFamily.selectedPfps
const searchValueSelector = state => state.admin.partnerSiteProductFamily.searchValue

const countSelector = state => state.admin.partnerSiteProductFamily.count
const pageSizeSelector = state => state.admin.partnerSiteProductFamily.pageSize
const currentPageSelector = state => state.admin.partnerSiteProductFamily.currentPage
const activeDialogSelector = state => state.admin.partnerSiteProductFamily.activePfpsDialog

const editSelector = state => state.admin.partnerSiteProductFamily.edit

const productFamilyEntitiesSelector = state => state.entities.product_hierarchy_views

const formattedPartnerSiteListSelector = createSelector(
    partnerSiteListSelector,
    (partnerSites) => {
        return Object.keys(partnerSites).map((id) => {
            return {
                value: id,
                label: partnerSites[id].name
            }
        })
    }
)

const formattedProductFamilyListSelector = createSelector(
    entitySelector,
    productFamilyListSelector,
    (entities, productFamilies) => {
        const product_hierarchies = entities.product_hierarchy_views
        return productFamilies.map( (id)=> {
            return {
                label: product_hierarchies[id].name,
                value: id
            }
        })
    }
)

const formattedProductFamilyPartnerSiteTableListSelector = createSelector(
    productFamilyPartnerSiteTableList,
    (pfps) => {
        return Object.values(pfps).map((mapping, idx) => {
            return {
                id: mapping.id,
                partner_site: mapping.partnerSiteName,
                product_family: mapping.productFamily,
                partner: mapping.partnerName
            }
        })
    }
)
const pageTotalSelector = createSelector(
    countSelector,
    pageSizeSelector,
    R.compose(
      Math.ceil,
      R.divide
    )
  )
  

const isFirstPageSelector = createSelector(
    currentPageSelector,
    R.equals(1)
  )
  
const isLastPageSelector = createSelector(
    currentPageSelector,
    pageTotalSelector,
    R.equals
)

const currentPfpsSelector = createSelector(
    selectedPfpsSelector,
    formattedProductFamilyPartnerSiteTableListSelector,
    (id, table) => {
        return (table.find((pfps) => pfps.id === id))
    }
)

export {
    activeAddProductFamilyDialogSelector,
    partnerSiteQuerySelector,
    partnerSiteListSelector,
    formattedPartnerSiteListSelector,
    selectedPartnerSite,
    selectedProductFamily,
    formattedProductFamilyListSelector,
    formattedProductFamilyPartnerSiteTableListSelector,
    selectedPfpsSelector,
    searchValueSelector,
    countSelector,
    pageSizeSelector,
    currentPageSelector,
    isFirstPageSelector,
    isLastPageSelector,

    editSelector,
    activeDialogSelector,
    currentPfpsSelector,
    productFamilyEntitiesSelector
}